import React from "react";
import { useState, useEffect } from "react";
import { InputGroup, Form } from "react-bootstrap";
import { formatHoursToInterval, parseIntervalToHours } from "../../../Data/Trails";

interface IntervalInputProps {
    value?: string | number | null | {hours?: number, minutes?: number}; // Backend interval (any format)
    onChange: (key: string, value: string) => void;
    field: string;
}

const IntervalInput: React.FC<IntervalInputProps> = ({ value, onChange, field }) => {
    // Convert interval string to hours for display
    const [hours, setHours] = useState<number>(() => {
        try {
            return parseIntervalToHours(value);
        } catch (error) {
            console.error('Error parsing interval to hours:', error, 'Value:', value);
            return 0;
        }
    });

    useEffect(() => {
        // Convert backend interval string to decimal hours for display
        try {
            setHours(parseIntervalToHours(value));
        } catch (error) {
            console.error('Error parsing interval to hours in useEffect:', error, 'Value:', value);
            setHours(0);
        }
    }, [value]);

    const handleHoursChange = (newHours: number) => {
        setHours(newHours);
        // Convert hours to interval string format for backend
        const intervalString = formatHoursToInterval(newHours);
        onChange(field, intervalString);
    };

    return (
        <InputGroup size="sm" className="mb-3">
            <InputGroup.Text
                id="inputGroup-sizing-sm" 
                className="meta-element-label"
            >Duration (Hours)</InputGroup.Text>
            <Form.Control
                type="number"
                value={hours}
                onChange={(e) => handleHoursChange(Number(e.target.value))}
                aria-label="Duration in hours"
                min="0"
                step="0.25"
                placeholder="e.g., 2.5 for 2h 30m"
            />
        </InputGroup>
    );
};

export default React.memo(IntervalInput);